module.exports = __webpack_public_path__ + "asset/questos--4bc641.svg";